export enum DossierStatusEnum {
	WAITING_FOR_PAYMENT = 'En attente de paiement',
	WAITING_FOR_DOCUMENT = 'En attente de documents/informations',
  ISSUED = 'Délivré',
  CANCELED = 'Annulé',
	COMPLETED = 'Terminé',
  COMPLETED_WITH_RESERVATION = "Terminé (en attente d'un autre permis)",
	PROCESSING = 'En traitement',
  WAITING_FOR_DECISION = 'En attente de décision',
  WAITING_FOR_APPROVAL = 'En attente d\'approbation',
  SUSPENDED = 'Suspendu',
  CANCELING = 'Annulation en cours'
}

export enum DossierStatusClassesEnum {
	COMPLETED = 'completed',
	PROCESSING = 'processing',
	WAITING_FOR_PAYMENT = 'waitingForPayment'
}